import dayjs from 'dayjs'

import { SchemaItem } from '@eastcoal/formily/components/SchemaForm/interface'

export const signUpStartTimeValidator: SchemaItem['x-validator'] = [
  {
    required: true
  },
  {
    validator(_, __, ctx) {
      const { signUpStartTime, signUpEndTime } = ctx.form.values

      if (dayjs(signUpStartTime).isBefore(dayjs())) {
        return '报名开始时间不能小于当前时间'
      }
      if (signUpEndTime && dayjs(signUpStartTime).isAfter(signUpEndTime)) {
        return '报名开始时间必须小于报名结束时间'
      }
      return null
    }
  }
]
